import { clsx } from 'clsx';
import type { PropsWithChildren } from 'react';
import { lazy } from 'react';

const NavBreadcrumbsHeader = lazy(
  () =>
    import(
      /* webpackChunkName: "NavBreadcrumbsHeader" */
      '../../navigation/breadcrumbs/NavBreadcrumbsHeader'
    ),
);

export type PageHeaderProps = {
  showBreadcrumbs?: boolean;
  headerClassName?: string;
  breadCrumbsClassName?: string;
  className?: string;
  enableProjectSwitcher?: boolean;
};

export function PageHeader({
  children,
  showBreadcrumbs = true,
  headerClassName,
  breadCrumbsClassName,
  className,
  enableProjectSwitcher = true,
}: PropsWithChildren<PageHeaderProps>) {
  return (
    <header className={clsx('bg-workspace flex w-full flex-col', className)}>
      {showBreadcrumbs ? (
        <NavBreadcrumbsHeader
          className={breadCrumbsClassName}
          enableProjectSwitcher={enableProjectSwitcher}
        />
      ) : null}
      {children ? (
        <div
          className={clsx(
            'ua-page-header px-2xl py-lg pb-md basis-topbarHeight flex shrink-0 items-center is-platform:px-lg is-platform:pt-md is-platform:pb-xl',
            headerClassName,
          )}
        >
          {children}
        </div>
      ) : null}
    </header>
  );
}
